/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
import {BannerImagem} from "./banner_imagem";
import {BannerTexto} from "./banner_texto";
export class Banner {
  constructor () {
    this.banner_id = uuidV4();
    this.efeito= 'fade';
    this.url_video= '';
    this.ordem= 0;
    this.tela_cheia= false;
    this.tem_imagem= false;
    this.is_video= false;
    this.banner_imagem= new BannerImagem(this.banner_id);
    this.banner_texto= new BannerTexto(this.banner_id);
    this.imagens= [];
    this.urls_imagem= [];
  }
}
